import React from "react";

const Unauthorized = () => {
    return (
        <p>Unauthorized!</p>
    );
}

export default Unauthorized;